// extracted by mini-css-extract-plugin
export var root = "N_wC";
export var wrapper = "N_sP";
export var image = "N_wD d_w d_y d_W";
export var imageWithHeight = "N_wF";
export var crop = "N_wG";
export var round = "N_wH";
export var fixedHeight = "N_wJ";